import React from 'react'
import PropTypes from 'prop-types'
import ExperienceBadge from './ExperienceBadge'
import { WHERE_LABELS, WHERE_COLOR_VARIANT } from './experienceNavigation'

/**
 * Workspace chrome for Enrol / Prep / Manage single-pane views.
 */
const ExperienceWorkspace = ({
  kicker,
  title,
  where = [],
  meta,
  description,
  actions,
  children,
}) => (
  <div className='experience-workspace'>
    <div className='experience-workspace-head'>
      <div>
        {kicker ? (
          <div className='experience-build-kicker'>{kicker}</div>
        ) : null}
        <div className='experience-ptitle'>
          <h2>{title}</h2>
          {where.map((key) => (
            <ExperienceBadge
              key={key}
              title={WHERE_LABELS[key] || key}
              variant={WHERE_COLOR_VARIANT[key] || 'taupe'}
            />
          ))}
          {meta ? <span className='experience-sec-meta'>{meta}</span> : null}
        </div>
      </div>
      {actions ? (
        <div className='experience-workspace-actions'>{actions}</div>
      ) : null}
    </div>
    {description ? <p className='experience-psub'>{description}</p> : null}
    {children}
  </div>
)

ExperienceWorkspace.propTypes = {
  kicker: PropTypes.string,
  title: PropTypes.string.isRequired,
  where: PropTypes.arrayOf(PropTypes.string),
  meta: PropTypes.node,
  description: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node,
}

export default ExperienceWorkspace
